const selectors = {
  form: '[data-coa-form]',
}

const coaForm = document.querySelector(selectors.form);

const handleCOAFormSubmit = (event) => {
  const form = event.target;
  const coaNumber = form.querySelector('input').value;
  event.preventDefault();
  const url = `/blogs/coa/${coaNumber}`;
  fetch(url)
    .then((response) => {
      if (response.status == 404) {
        window.location = '/blogs/coa/coa-lookup-failure';
      } else {
        window.location = url;
      }
    });
};

if (coaForm) {
  coaForm.addEventListener('submit', handleCOAFormSubmit);
}
